import { useEffect, useState } from "react";
const initialConvo = [
  {
    body: "Hello! How can I assist you today?",
    direction: "out",
    initialMessage: true,
  },
];
function useFakebotConvo(clinicId) {
  const [fakebotConvo, setFakebotConvo] = useState(initialConvo);

  function updateLocalStorageConvo(newConvo = [], reset = false) {
    const localStorageData = JSON.parse(localStorage.getItem("fakebot_convo"));
    setFakebotConvo(reset ? initialConvo : newConvo);
    localStorage.setItem(
      "fakebot_convo",
      JSON.stringify({
        ...localStorageData,
        [clinicId]: [...(reset ? initialConvo : newConvo)],
      })
    );
  }

  useEffect(() => {
    if (clinicId) {
      const localStorageData = JSON.parse(
        localStorage.getItem("fakebot_convo")
      );
      if (localStorageData && localStorageData[clinicId]) {
        setFakebotConvo(localStorageData[clinicId]);
      } else {
        updateLocalStorageConvo(initialConvo);
      }
    }
  }, [clinicId]);

  return [fakebotConvo, updateLocalStorageConvo];
}

export default useFakebotConvo;
